export default __webpack_public_path__ + "static/media/md8-information-systems.ff1c457f.svg";